let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("euA5f")]).then(() => parcelRequire('bZz8I'));